import { render, staticRenderFns } from "./listCollaborators.vue?vue&type=template&id=40410283"
import script from "./listCollaborators.vue?vue&type=script&lang=js"
export * from "./listCollaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports